const detectOutOfScheduleItemsInCartFun = (currentOrder, menuItemSchedules) => {
  return currentOrder?.menuItems?.some(({ _id }) => {
    return menuItemSchedules?.some(
      ({ menuItemId, isAvailableNow }) => menuItemId === _id && !isAvailableNow
    );
  });
};

export const detectOutOfScheduleItemsInCart = detectOutOfScheduleItemsInCartFun;
